import React, { Component } from 'react';
import { HttpService } from 'services/HttpService';
import { CircleLoader } from 'components/CircleLoader/CircleLoader';

export class PaymentSettingsPage extends Component {
  constructor(props) {
    super(props)
  }

  componentWillMount() {
    this.handle();
  }

  handle = async (event) => {
    const host = process.env.REACT_APP_SERVER;
    const body = {
      addToken: true
    };
    new HttpService().sendRequest(`${host}/api/users/payment`, {
      body: JSON.stringify(body),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((result) => {
      if (result.hasOwnProperty('url')) {
        window.location.href = result.url;
      }else{
        window.location.href = "/research"
      }
    }).catch((err, code) => {
      console.log(err);
    });
  }

  render() {
    return (
      <div className="margin-t-100">
        <CircleLoader isActive={true} />
      </div>
    )
  }
}

export default PaymentSettingsPage
